import Home from './component/pages/Home/index'
import CommonProblem from './component/pages/CommonProblem/index'
import ContactUs from './component/pages/ContactUs/index'
import VersionInfo from './component/pages/VersionInfo/index'
import Intro from './component/pages/Intro/index'
import ProductDownload from './component/pages/ProductDownload/index'
import ITPro from './component/pages/production/ItIndex'
import ScpController from './component/pages/ScpController/index'
import { routePath } from './config'
export const routes = [
  {
    path: routePath.home,
    component: Home,
    name: 'header001',
    isShow: true,
    isTWShow: true,
    isCNShow: true,
    list: [
      {
        path: routePath.home,
        component: Home,
        name: 'header001',
      },
      {
        path: routePath.itPro,
        component: ITPro,
        name: 'header002',
      },
    ],
  },
  {
    path: routePath.intro,
    component: Intro,
    name: 'header005',
    isShow: false,
    isTWShow: true,
    isCNShow: false,
    list: [],
  },
  {
    path: routePath.commonProblem,
    component: CommonProblem,
    name: 'header002',
    isShow: true,
    isTWShow: false,
    isCNShow: true,
    list: [],
  },
  {
    path: routePath.versionInfo,
    component: VersionInfo,
    name: 'header003',
    isShow: false,
    isTWShow: false,
    isCNShow: false,
    list: [],
  },
  {
    path: routePath.contactUs,
    component: ContactUs,
    name: 'header004',
    isShow: true,
    isTWShow: true,
    isCNShow: true,
    list: [],
  },
  {
    path: routePath.productDownload,
    component: ProductDownload,
    name: 'header006',
    isShow: true,
    isTWShow: true,
    isCNShow: true,
    list: [],
  },
]
